import { render, staticRenderFns } from "./pharmacistContactData.vue?vue&type=template&id=0182d51a&scoped=true"
import script from "./pharmacistContactData.vue?vue&type=script&lang=js"
export * from "./pharmacistContactData.vue?vue&type=script&lang=js"
import style0 from "./pharmacistContactData.vue?vue&type=style&index=0&id=0182d51a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0182d51a",
  null
  
)

export default component.exports